import React from "react";

import { useTheme } from "../../../utils/Theme";

import { SVGProps } from "./SVG.props";

const SnowRain = (props: SVGProps): JSX.Element => {
  const theme = useTheme();
  const { width, height, fill } = props;

  // Paste converted svg below
  // https://react-svgr.com/playground/?typescript=true
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 24}
      height={height || 24}
      fill="none"
      viewBox="0 0 240 194"
    >
      <path
        fill="url(#paint0_linear_2496_18986)"
        d="M75.309 115.192a5.764 5.764 0 015.764-5.764 5.764 5.764 0 015.765 5.764v43.11a5.765 5.765 0 11-11.53 0v-43.11z"
      ></path>
      <path
        fill="url(#paint1_linear_2496_18986)"
        d="M98.368 123.213a5.764 5.764 0 1111.529 0v52.133a5.765 5.765 0 11-11.53 0v-52.133z"
      ></path>
      <path
        fill="url(#paint2_linear_2496_18986)"
        d="M121.426 110.681a5.765 5.765 0 1111.53 0v38.097a5.765 5.765 0 11-11.53 0v-38.097z"
      ></path>
      <path
        fill="url(#paint3_linear_2496_18986)"
        d="M144.485 110.681a5.765 5.765 0 1111.53 0v47.621a5.765 5.765 0 11-11.53 0v-47.621z"
      ></path>
      <path
        fill="url(#paint4_linear_2496_18986)"
        d="M144.485 174.845a5.765 5.765 0 1111.53 0v13.033a5.765 5.765 0 11-11.53 0v-13.033z"
      ></path>
      <path
        fill="url(#paint5_linear_2496_18986)"
        d="M121.426 166.824a5.765 5.765 0 1111.53 0v16.041a5.765 5.765 0 11-11.53 0v-16.041z"
      ></path>
      <path
        fill="url(#paint6_linear_2496_18986)"
        d="M75.309 177.852a5.764 5.764 0 015.764-5.764 5.764 5.764 0 015.765 5.764v5.013a5.765 5.765 0 11-11.53 0v-5.013z"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M227.018 138.543L227.018 162.953"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M224.109 140.449l2.943 2.942 2.674-2.942M229.727 162.383l-2.943-2.942-2.674 2.942M225.715 144.998l1.337 1.337 1.338-1.337M228.121 158.104l-1.337-1.338-1.338 1.338"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M239.125 150.848L214.715 150.848"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M237.219 147.939l-2.942 2.943 2.942 2.674M215.285 153.557l2.942-2.943-2.942-2.674M232.67 149.545l-1.337 1.337 1.337 1.338M219.566 151.953l1.338-1.337-1.338-1.338"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M235.611 141.961L218.351 159.222"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M232.135 141.523v4.161l3.972-.189M220.633 160.781v-4.161l-3.972.189M230.262 145.535v1.891h1.891M222.773 156.77v-1.892h-1.891"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M235.711 159.439L218.45 142.179"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M236.152 155.963h-4.161l.19 3.972M216.893 144.461h4.161l-.19-3.972M232.139 154.09h-1.892v1.891M220.904 146.6h1.892v-1.892"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2"
        d="M16.904 49.096L16.904 79.944"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2"
        d="M12.793 51.207l3.803 3.804 3.458-3.804M20.055 79.56l-3.804-3.803-3.458 3.803M14.87 57.086l1.728 1.729 1.729-1.73M17.979 74.03l-1.73-1.73-1.728 1.73"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2"
        d="M31.848 65.002L0.999 65.002"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2"
        d="M29.736 60.889l-3.803 3.803 3.803 3.458M1.383 68.15l3.803-3.803-3.803-3.458M23.855 62.965l-1.728 1.729 1.729 1.729M6.916 66.078l1.729-1.729-1.729-1.729"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2"
        d="M27.662 53.66L5.849 75.474"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2"
        d="M23.166 52.594v5.379l5.134-.245M8.299 77.488V72.11l-5.135.245M20.746 57.78v2.444h2.445M11.065 72.303v-2.445H8.619"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2"
        d="M27.287 75.756L5.474 53.943"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2"
        d="M28.355 71.262h-5.378l.244 5.134M3.459 56.393h5.379l-.245-5.135M23.168 68.842h-2.445v2.445M8.645 59.158h2.444v-2.445"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M53.715 129.016L53.715 150.245"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M51.11 130.621l2.573 2.574 2.34-2.574M56.023 149.809l-2.574-2.574-2.34 2.574M52.514 134.6l1.17 1.17 1.17-1.17M54.62 146.066l-1.17-1.17-1.17 1.17"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M64.184 139.779L42.954 139.779"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M62.578 137.172l-2.574 2.574 2.574 2.34M43.39 142.086l2.575-2.574-2.574-2.34M58.6 138.576l-1.17 1.17 1.17 1.17M47.135 140.684l1.17-1.17-1.17-1.17"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M61.174 132.033L46.162 147.045"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M58.13 131.561v3.64l3.475-.166M48.068 148.408v-3.64l-3.474.166M56.492 135.07v1.655h1.655M49.941 144.898v-1.654h-1.654"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M61.168 147.234L46.156 132.223"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M61.643 144.193h-3.64l.165 3.475M44.795 134.131h3.64l-.165-3.475M58.13 142.555h-1.654v1.654M48.303 136.002h1.654v-1.655"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M205.904 25.25L205.904 41.331"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M203.785 26.367l1.978 1.978 1.798-1.978M207.561 41.111l-1.978-1.977-1.798 1.977M204.865 29.426l.899.899.899-.9M206.48 38.236l-.899-.899-.899.9"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M213.715 33.52L197.634 33.52"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M212.598 31.4l-1.978 1.978 1.978 1.798M197.854 35.176l1.977-1.978-1.977-1.798M209.539 32.478l-.899.9.899.898M200.73 34.1l.899-.9-.899-.898"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M211.516 27.615L200.145 38.986"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M209.178 27.09v2.797l2.67-.127M201.447 40.035v-2.797l-2.67.127M207.92 29.785v1.271h1.271M202.885 37.338v-1.272h-1.272"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M211.351 39.133L199.98 27.762"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M211.879 36.797h-2.797l.127 2.67M198.932 29.064h2.797l-.127-2.67M209.18 35.537h-1.272v1.272M201.629 30.502h1.271v-1.271"
      ></path>
      <g filter="url(#filter0_bdi_2496_18986)">
        <path
          fill="url(#paint7_radial_2496_18986)"
          fillOpacity="0.77"
          fillRule="evenodd"
          d="M74.246 146.905c-.29.007-.582.01-.875.01-21.76 0-39.4-17.64-39.4-39.401 0-14.767 8.124-27.637 20.147-34.384a66.49 66.49 0 01-.01-1.076c0-36.026 29.205-65.23 65.231-65.23 31.074 0 57.074 21.73 63.633 50.822 23.776 1 42.746 20.592 42.746 44.614 0 24.662-19.993 44.654-44.654 44.654-.292 0-.584-.003-.874-.008v.006H74.246v-.007z"
          clipRule="evenodd"
        ></path>
      </g>
      <g
        style={{ mixBlendMode: "soft-light" }}
        filter="url(#filter1_di_2496_18986)"
      >
        <circle cx="73.369" cy="107.514" r="39.4" fill="#848484"></circle>
      </g>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="4"
        d="M167.32 102.33L167.32 181.509"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="4"
        d="M157.441 108.211l9.632 9.631 8.755-9.631M175.828 180.006l-9.631-9.631-8.756 9.631M162.697 123.098l4.378 4.377 4.378-4.377M170.572 166l-4.378-4.378-4.377 4.378"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="4"
        d="M206.229 142.605L127.05 142.605"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="4"
        d="M200.35 132.725l-9.632 9.631 9.632 8.755M128.553 151.113l9.631-9.631-9.631-8.756M185.463 137.98l-4.378 4.378 4.378 4.378M142.564 145.857l4.378-4.377-4.378-4.378"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="4"
        d="M195.096 113.668L139.108 169.656"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="4"
        d="M183.709 111.715v13.62l13.001-.619M146.062 174.75v-13.621l-13.001.62M177.584 124.846v6.191h6.191M153.068 161.623v-6.191h-6.191"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="4"
        d="M194.898 170.373L138.91 114.385"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="4"
        d="M196.854 158.99h-13.621l.619 13.002M133.812 121.34h13.621l-.619-13.002M183.717 152.861h-6.191v6.192M146.943 128.344h6.192v-6.191"
      ></path>
      <defs>
        <filter
          id="filter0_bdi_2496_18986"
          width="217.369"
          height="165.713"
          x="21.159"
          y="0.419"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur
            in="BackgroundImageFix"
            stdDeviation="3.203"
          ></feGaussianBlur>
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2496_18986"
          ></feComposite>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="6.406"></feOffset>
          <feGaussianBlur stdDeviation="6.406"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.2015 0 0 0 0 0.3875 0 0 0 0.2 0"></feColorMatrix>
          <feBlend
            in2="effect1_backgroundBlur_2496_18986"
            result="effect2_dropShadow_2496_18986"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_2496_18986"
            result="shape"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dx="0.4" dy="0.801"></feOffset>
          <feGaussianBlur stdDeviation="2.803"></feGaussianBlur>
          <feComposite
            in2="hardAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
          ></feComposite>
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"></feColorMatrix>
          <feBlend
            in2="shape"
            result="effect3_innerShadow_2496_18986"
          ></feBlend>
        </filter>
        <filter
          id="filter1_di_2496_18986"
          width="90.811"
          height="90.011"
          x="30.766"
          y="61.708"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dx="-0.801" dy="-4.004"></feOffset>
          <feGaussianBlur stdDeviation="1.201"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2496_18986"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_2496_18986"
            result="shape"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dx="8.808" dy="4.804"></feOffset>
          <feGaussianBlur stdDeviation="4.404"></feGaussianBlur>
          <feComposite
            in2="hardAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
          ></feComposite>
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.74 0"></feColorMatrix>
          <feBlend
            in2="shape"
            result="effect2_innerShadow_2496_18986"
          ></feBlend>
        </filter>
        <linearGradient
          id="paint0_linear_2496_18986"
          x1="115.662"
          x2="115.558"
          y1="104.916"
          y2="180.744"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.318" stopColor="#3675D7"></stop>
          <stop offset="0.724" stopColor="#25CDF4"></stop>
          <stop offset="0.885" stopColor="#7CDEE9"></stop>
          <stop offset="1" stopColor="#67EBF7"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_2496_18986"
          x1="115.662"
          x2="115.558"
          y1="104.916"
          y2="180.744"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.318" stopColor="#3675D7"></stop>
          <stop offset="0.724" stopColor="#25CDF4"></stop>
          <stop offset="0.885" stopColor="#7CDEE9"></stop>
          <stop offset="1" stopColor="#67EBF7"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_2496_18986"
          x1="115.662"
          x2="115.558"
          y1="104.916"
          y2="180.744"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.318" stopColor="#3675D7"></stop>
          <stop offset="0.724" stopColor="#25CDF4"></stop>
          <stop offset="0.885" stopColor="#7CDEE9"></stop>
          <stop offset="1" stopColor="#67EBF7"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_2496_18986"
          x1="115.662"
          x2="115.558"
          y1="104.916"
          y2="180.744"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.318" stopColor="#3675D7"></stop>
          <stop offset="0.724" stopColor="#25CDF4"></stop>
          <stop offset="0.885" stopColor="#7CDEE9"></stop>
          <stop offset="1" stopColor="#67EBF7"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_2496_18986"
          x1="115.662"
          x2="115.558"
          y1="104.916"
          y2="180.744"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.318" stopColor="#3675D7"></stop>
          <stop offset="0.724" stopColor="#25CDF4"></stop>
          <stop offset="0.885" stopColor="#7CDEE9"></stop>
          <stop offset="1" stopColor="#67EBF7"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_2496_18986"
          x1="115.662"
          x2="115.558"
          y1="104.916"
          y2="180.744"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.318" stopColor="#3675D7"></stop>
          <stop offset="0.724" stopColor="#25CDF4"></stop>
          <stop offset="0.885" stopColor="#7CDEE9"></stop>
          <stop offset="1" stopColor="#67EBF7"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_2496_18986"
          x1="115.662"
          x2="115.558"
          y1="104.916"
          y2="180.744"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.318" stopColor="#3675D7"></stop>
          <stop offset="0.724" stopColor="#25CDF4"></stop>
          <stop offset="0.885" stopColor="#7CDEE9"></stop>
          <stop offset="1" stopColor="#67EBF7"></stop>
        </linearGradient>
        <radialGradient
          id="paint7_radial_2496_18986"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(90.669 32.632 68.523) scale(110.171 125.719)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#99CEFF"></stop>
        </radialGradient>
      </defs>
    </svg>
  );
};

export default SnowRain;
